<template>
    <modal
        :value="value"
        width="200"
        content-class="ssid-create"
        @input="closeModal"
    >
        <div class="form-body">
            <h1 class="text-muted text-center">
                {{ $t("message.ssid.message.newSSID") }}
            </h1>
            <v-text-field
                v-model.trim="form.name"
                :label="$t('message.generics.message.name')"
                :name="$t('message.generics.message.name')"
                v-validate="'required'"
                :error-messages="
                    errors.collect($t('message.generics.message.name'))
                "
            ></v-text-field>
        </div>

        <div class="card-footer">
            <app-button
                :disabled="!form.name"
                class="btn btn-primary btn-round"
                :label="$t('message.generics.message.create')"
                primary
                @click="create()"
            />
        </div>
    </modal>
</template>

<script>
import EventBus from "@packages/event-bus/index";
import AppButton from "@/components/generic/button/Button";
import Modal from "@/components/generic/Modal";

export default {
    components: {
        AppButton,
        Modal,
    },

    data() {
        return {
            controlTypes: [],
            form: {
                name: "",
            },
        };
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        async create() {
            EventBus.$emit("SHOW_SPINNER");

            try {
                await this.$api.core.ssid.create({
                    ...this.form,
                });

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: this.$t(
                        "message.successMessages.message.recordSaved"
                    ),
                });

                this.$emit("submit");
                this.closeModal();
            } catch (error) {
                console.log(error);
            } finally {
                EventBus.$emit("CANCEL_SPINNER");
            }
        },

        closeModal() {
            this.$emit("input", false);
        },
    },
};
</script>

<style lang="scss" scoped>
.form-body {
    padding: 18px 50px 10px;
}

.type-body {
    display: inline;
    align-items: center;
    justify-content: center;
}

.card-footer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-round .v-card .card-body {
    min-height: 125px;
    overflow-x: hidden;
}
</style>
